export default __webpack_public_path__ + "static/media/event_bg_default2.ab83bcb8.svg";